<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                id: '',
                voucher: '',
            },
            tax: {
                id: '',
                company_id: '',
                capture_line: '',
                statement: '',
                amount: '',
                date: '',
                deadline: '',
                type_taxes_id: '',
                type_payment_id: '',
                voucher: '',
                voucher_two: '',
            },
            voucher: '',
            voucher_name: '',

            voucher_two: '',
            voucher_two_name: '',


            capture_line: '',
            capture_line_name: '',
            statement: '',
            statement_name: '',

            send: false,
            load: false,
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.form.company_id = '';
            this.form.capture_line = '';
            this.form.statement = '';
            this.form.amount = '';
            this.form.date = '';
            this.form.deadline = '';
            this.form.type_taxes_id = '';
            this.form.type_payment_id = '';
            this.capture_line = '';
            this.capture_line_name = '';
            this.statement = '';
            this.statement_name = '';
            this.send = false;
            this.load = false;
            this.form.voucher = '';
            this.form.voucher_two = '';
            this.capture_line = '';
            this.capture_line_name = '';
            this.statement = '';
            this.statement_name = '';

            this.voucher = '';
            this.voucher_name = '';

            this.voucher_two = '';
            this.voucher_two_name = '';

            this.$modal.hide('addVoucher');

        },
        catch_voucher(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.voucher = event.target.files[0];
                this.voucher_name = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        catch_voucher_two(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.voucher_two = event.target.files[0];
                this.voucher_two_name = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        async saveTaxes() {
            const data_form = new FormData();
            data_form.append('id', this.form.id)
            data_form.append('company_id', this.tax.company_id)
            data_form.append('capture_line', this.tax.capture_line)
            data_form.append('statement', this.tax.statement)
            data_form.append('amount', this.tax.amount)
            data_form.append('date', this.tax.date)
            data_form.append('deadline', this.tax.deadline)
            data_form.append('type_taxes_id', this.tax.type_taxes_id)
            data_form.append('type_payment_id', this.tax.type_payment_id)


            data_form.append('voucher', this.form.voucher)
            data_form.append('voucher_two', this.form.voucher_two)

            let _endpoint = '/taxes';
            if (this.form.id != "") {
                data_form.append('_method', 'PUT');
                _endpoint = `/taxes/${this.form.id}`;
            }

            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-taxes');
                    Event.$emit('event-load-checks');
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }

        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-addVoucher", async (_tax) => {
            console.log(_tax);
            if (_tax.id) {
                this.form.id = _tax.id;
                this.tax.id = _tax.id;
                this.tax.company_id = _tax.company_id;
                this.tax.amount = _tax.amount;
                this.tax.date = _tax.date;
                if (_tax.deadline) {
                    this.tax.deadline = _tax.deadline;
                }
                this.tax.type_taxes_id = _tax.type_taxes_id;
                this.file = _tax.file;
                this.capture_line = _tax.capture_line;
                this.statement = _tax.statement;
                this.tax.type_payment_id = _tax.type_payment_id;
                if (_tax.voucher) {
                    this.voucher = _tax.voucher;
                }
                if (_tax.voucher_two) {
                    this.voucher_two = _tax.voucher_two;
                }


            }
            this.$modal.show('addVoucher');

        })
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    async mounted() {
        this.catalogue.get_companies_buildings();
        this.catalogue.get_taxes_types();
        this.catalogue.get_type_payments();
    }
}
</script>
<template>
    <modal name="addVoucher" :width="'80%'" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>

        <form @submit.prevent="saveTaxes" method="post" id="formTax" enctype="multipart/form-data">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel">Información Factura</h5>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-md-6">
                        <label>Línea de captura</label><br>
                        <a :href="`${globalUrlFiles}${capture_line}`" v-if="capture_line != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-block btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.capture_line" class="text-danger">{{ errors.capture_line[0] }}</div>

                    </div>
                    <div class="col-md-6">
                        <label>Declaración</label><br>
                        <a :href="`${globalUrlFiles}${statement}`" v-if="statement != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-block btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.statement" class="text-danger">{{ errors.statement[0] }}</div>

                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Empresa</label>
                        <select disabled type="text" class="form-control" v-model="tax.company_id">
                            <option v-for="(company, index) in catalogue.companies_buildings" :value="company.id"
                                :key="index">
                                {{ company.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.company_id" class="text-danger">{{ errors.company_id[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Fecha</label>
                        <date-picker v-model="tax.date" disabled required="required" valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Fecha límite</label>
                        <date-picker v-model="tax.deadline" disabled required="required"
                            valueType="format"></date-picker>
                        <div v-if="errors && errors.deadline" class="text-danger">{{ errors.deadline[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Monto</label>
                        <money disabled class="form-control" v-model="tax.amount"></money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Tipo</label>
                        <select disabled type="text" class="form-control" v-model="tax.type_taxes_id">
                            <option v-for="(type, index) in catalogue.taxes_types" :value="type.id" :key="index">
                                {{ type.name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.type_taxes_id" class="text-danger">{{ errors.type_taxes_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-3">
                        <label>Tipo de saldo</label>
                        <select type="text" disabled class="form-control" v-model="tax.type_payment_id">
                            <option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
                                :value="type_payment.id" :key="index_type_payment">{{
        type_payment.name }}</option>
                        </select>
                        <div v-if="errors && errors.type_payment_id" class="text-danger">{{ errors.type_payment_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Comprobante</label><br>
                        <div class="custom-file" :style="voucher != '' ? 'width: 87%' : 'width: 100%'">
                            <input type="file" required :disabled="!prop_edit" class="custom-file-input"
                                :class="file != '' ? 'pr-5' : ''" id="customFile" ref="file" @change="catch_voucher">
                            <label class="custom-file-label text-left" for="customFile">{{ voucher_name }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${voucher}`" v-if="voucher != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.voucher" class="text-danger">{{ errors.voucher[0] }}</div>

                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Comprobante extra</label><br>
                        <div class="custom-file" :style="voucher_two != '' ? 'width: 87%' : 'width: 100%'">
                            <input type="file" required :disabled="!prop_edit" class="custom-file-input"
                                :class="file != '' ? 'pr-5' : ''" id="customFile" ref="file" @change="catch_voucher_two">
                            <label class="custom-file-label text-left" for="customFile">{{ voucher_two_name }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${voucher_two}`" v-if="voucher_two != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.voucher_two" class="text-danger">{{ errors.voucher_two[0] }}</div>

                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>

                </div>


            </div>
        </form>
    </modal>
</template>